<template>
  <div class="notice-box">
    <div class="header">
      <div class="text1">通知公告</div>
      <div class="header-info">
        <div class="info-box flex align-items-center flex-center">
          <div>时间 :<span style="color: #927451"> 2022-01-12 </span></div>
          <div style="margin-left: 75px">
            上传人 :<span style="color: #927451"> 张元一 </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      为深入学习贯彻习近平总书记对职业教育工作重要指示和/全国职业教育大会精神，认真落实《国家职业教育改革实施方案》
      《山西省推进职业教育改革发展行动计划》 ，
      决定实施山西省职业教育铸魂育人计划。现将有关事宜通知如下：
      <div class="division-box">
        <div class="top-card">总体要求</div>
        <div class="bottom-line"></div>
      </div>
      （一）指导思想 以习近平新时代中国特色社会主义思想为指导，
      全面贯彻党的教育方针，落实立德树人根本任务，加强思政能力建设，打造思政教育品牌，构筑铸魂育人新高某某，构建全员全过程全方位育人新格局，引导职业学校（含高等职业学校、中等职业学校和技工学校，下同）学生增强“四个自信"，厚植爱国主义/情怀，做德智体美劳全面发展的社会主义建设者和接班人。

      <div class="division-box">
        <div class="top-card">总体要求</div>
        <div class="bottom-line"></div>
      </div>
      紧紧围绕立德树人根本任务，深入推进全省职业教育改革/创新，全面推动习近平新时代中国特色社会主义思想进教材、进课堂、进头脑，用五年时间，实施以“建设100个思政教育工作室、打造1000个特色文化育人品牌、开发10000个课程某某微课"为主要内容的职业教育铸魂育人计划（以下简称“
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.notice-box {
  padding: 15px 30px;
}
.text1 {
  font-size: 26px;
  margin-top: 10px;
  text-align: center;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.header {
  .header-info {
    height: 38px;
    margin-top: 20px;
    background: #fff6ec;
    .info-box {
      height: 100%;
    }
  }
}
.content {
  margin-top: 48px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #282828;
  line-height: 46px;
  .division-box {
    margin-top:15px;
    .top-card {
      width: 160px;
      height: 34px;
      line-height: 36px;
      text-align: center;
      border-radius: 10px 10px 0px 0px;
      color: #fff6ec;
      background: #c73630;
    }
    .bottom-line {
      height: 3px;
      background: #c73630;
    }
  }
}
</style>
